import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import SplashScreen from 'common/components/SplashScreen';
import {pathnames as P} from 'common/constants/pathnames';
import {localStorageKeys as K} from '../../../../common/constants/localStorageKeys';
import {persistor} from '../../../../store/configureStore';

class Logout extends Component {
  componentDidMount() {
    Promise.resolve()
      .then(() => {
        localStorage.removeItem(K.STORED_PATH);
      })
      .then(() => this.props.logout(this.props.accessToken))
      .then(() => persistor.purge())
      .finally(this.checkAuthenticatedAndRedirect)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.checkAuthenticatedAndRedirect();
  }

  checkAuthenticatedAndRedirect = () => {
    const {history} = this.props;
    if (!this.isAuthenticated()) history.push(P.AUTH_LOGIN);
  };

  isAuthenticated = () => {
    const {accessToken, user} = this.props;
    return Boolean(accessToken) && Boolean(user);
  };

  render() {
    return (this.isAuthenticated())
      ? <SplashScreen/>
      : <Redirect to={P.AUTH_LOGIN}/>;
  }
}

Logout.propTypes = {
  logout: PropTypes.func,
  accessToken: PropTypes.string,
  user: PropTypes.object
};

export default Logout;
